export default __webpack_public_path__ + "static/media/E2.1ff19061.mp3";